import { Badge } from '@/components/ui/Badge'
import { Building2, User } from 'lucide-react'
import type { ClientType } from '@/types/client'

interface TypeClientBadgeProps {
  type: ClientType
  size?: 'sm' | 'md'
  showIcon?: boolean
}

export function TypeClientBadge({
  type,
  size = 'md',
  showIcon = true,
}: TypeClientBadgeProps) {
  const isPro = type === 'professionnel'

  return (
    <Badge variant={isPro ? 'gold' : 'mint'} size={size}>
      {showIcon && (
        isPro ? (
          <Building2 className="w-3 h-3 mr-1" />
        ) : (
          <User className="w-3 h-3 mr-1" />
        )
      )}
      {isPro ? 'Pro' : 'Particulier'}
    </Badge>
  )
}
